import { Link } from "react-router-dom";

function PurchaseFailedPage() {
  return (
    <div style={{ background: "#f9fafb", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ maxWidth: "500px", textAlign: "center", background: "white", padding: "40px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0,0,0,0.05)" }}>
        <div style={{ fontSize: "60px", marginBottom: "20px" }}>😕</div>
        <h1 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "1.5rem", fontWeight: "700", marginBottom: "10px", color: "#dc2626" }}>Payment Failed</h1>
        <p style={{ color: "#374151", marginBottom: "30px" }}>Unfortunately, your payment could not be processed. Please try again.</p>
        
        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <Link 
            to="/" 
            style={{ background: "#f3f4f6", color: "#374151", padding: "12px 24px", borderRadius: "10px", textDecoration: "none", fontWeight: "600" }}
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PurchaseFailedPage;
